// Helpers for the "filter options are in ascending alphabetical order" convention.
// Natural / numeric-aware, case-insensitive: "Grade 5" < "Grade 10".
const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

export const cmpAsc = (a, b) => collator.compare(String(a ?? ''), String(b ?? ''));

// Returns a new array sorted ascending. `key` may be a property name, a function, or omitted (plain values).
export const sortAsc = (list, key) => {
  const arr = Array.isArray(list) ? [...list] : [];
  const get = typeof key === 'function' ? key : key ? (x => x?.[key]) : (x => x);
  return arr.sort((a, b) => cmpAsc(get(a), get(b)));
};

// Sort classes / subjects / teachers etc. by their name.
export const sortByName = (list) => sortAsc(list, x => x?.name ?? x?.className ?? x?.title ?? '');

// Merge portal-role tabs with non-portal designation tabs into one A→Z list (by label).
export const mergeSortedTabs = (portalTabs, designations, colors) =>
  sortAsc([
    ...portalTabs,
    ...(designations || []).map((d, i) => ({ key: d, label: d, color: colors[i % colors.length] })),
  ], 'label');
